<div class="container mt-5 mb-6 flex-auto flex-col mx-10" [@expandCollapse]>
  <div class="top-0 z-10 bg-white">    
      <table class="w-full table-fixed mat-elevation-z" mat-table [dataSource]="dataSource" matSort
          (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

          <ng-container matColumnDef="view">
            <th mat-header-cell *matHeaderCellDef class=" text-left first-col table-tittle " style="min-width: 40px; width: 70px;">
              
            </th>
            <td mat-cell *matCellDef="let element" class=" w-2 text-left first-col table-text ">
              <button mat-icon-button  matTooltip="Acciones">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </td>
        </ng-container>

          <ng-container matColumnDef="material">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-5 text-left first-col table-tittle">Material</th>
            <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
              <p class="table-text-m" style="min-width: 102px;">
                <span class="table-text-code">
                  {{ element?.material.externalKeys.code ?? element?.material.code ?? '-' }}<br>
                </span>
                {{ element?.material.name ?? '-' }}
              </p>
            </td>
          </ng-container>

          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef class=" text-left first-col table-tittle text-right">
              <span class="table-text-m-2">Precio {{ 'code' | companyCurrency: true }}</span>
            </th>
            <td mat-cell *matCellDef="let element" class=" text-left first-col table-text text-right">
              <p class="table-text-m-2">
                {{ (element?.unitPrice | number : '1.2') }}
              </p>
            </td>
        </ng-container>

        <ng-container matColumnDef="baseQuantity">
            <th mat-header-cell *matHeaderCellDef class="text-left first-col table-tittle">
              <span class="table-text-m-2">Cnt. Solicitada <br> <span class="ml-2">{{UMPActive ? '(UMB / UMP)' : '(UMB)'}}</span> </span>
            </th>
            <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
              <div class="table-text-m-2">
                <app-unit-measure-display
                  class="f-9"
                  [baseUnit]="{
                    quantity: element?.baseQuantity,
                    unitId: element?.baseUnitOfMeasure?._id,
                    unitName: element?.baseUnitOfMeasure?.name,
                    unitAbbreviation: element?.baseUnitOfMeasure?.code
                  }"
                  [parallelUnit]="{
                    quantity: element?.pararellQuantity,
                    unitId: element?.pararellUnitOfMeasure?._id,
                    unitName: element?.pararellUnitOfMeasure?.name,
                    unitAbbreviation: element?.pararellUnitOfMeasure?.code
                  }"
                  [material]="{
                    _id: element?.material?._id,
                    code: element?.material?.code,
                    UMPActive: element?.material?.UMPActive ?? false
                  }"
                  [companyUMPActive]="UMPActive"
                ></app-unit-measure-display>
              </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="soldQuantity">
          <th mat-header-cell *matHeaderCellDef class=" text-left first-col table-tittle">
            <span class="table-text-m-2 pd-l">Cnt. Solicitada</span>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
            <div class="table-text-m-2 pd-l">
              <app-unit-measure-display
                class="f-9"
                [usedUnit]="{
                  quantity: element?.soldQuantity,
                  unitId: element?.soldUnitOfMeasure?._id,
                  unitName: element?.soldUnitOfMeasure?.name,
                  unitAbbreviation: element?.soldUnitOfMeasure?.code
                }"
                [baseUnit]="{
                  quantity: element?.baseQuantity,
                  unitId: element?.baseUnitOfMeasure?._id,
                  unitName: element?.baseUnitOfMeasure?.name,
                  unitAbbreviation: element?.baseUnitOfMeasure?.code
                }"
                [parallelUnit]="{
                  quantity: element?.pararellQuantity,
                  unitId: element?.pararellUnitOfMeasure?._id,
                  unitName: element?.pararellUnitOfMeasure?.name,
                  unitAbbreviation: element?.pararellUnitOfMeasure?.code
                }"
                [material]="{
                  _id: element?.material?._id,
                  code: element?.material?.code,
                  UMPActive: element?.material?.UMPActive ?? false
                }"
                [companyUMPActive]="UMPActive"
              ></app-unit-measure-display>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="stockConfirmedERP">
            <th mat-header-cell *matHeaderCellDef class=" text-left first-col table-tittle text-right">
              <span class="table-text-m-2">Cnt. Confirmada</span>
            </th>
            <td mat-cell *matCellDef="let element" class=" text-left first-col table-text text-right">
              <p class="table-text-m-2">
                {{ element.stockConfirmedERP ? (element.stockConfirmedERP ?? 0 | number : '1.3') : '-'}}
              </p>
            </td>
        </ng-container>

        <ng-container matColumnDef="unificationCode">
            <th mat-header-cell *matHeaderCellDef class="pr-5 text-left first-col table-tittle text-right">
              <span class="table-text-m-2">Cod. Unificación</span>
            </th>
            <td mat-cell *matCellDef="let element" class=" text-left first-col table-text text-right">
              <p class="table-text-m-2">
                {{element.sourceTransaction && element.sourceTransaction?.length > 1 ? element.sourceTransaction[0].serial : '-'}}
              </p>
            </td>
        </ng-container>

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 dark:bg-gray-900"></tr>
        <!-- Fila principal -->
        <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="border-b "></tr>

      </table>
  </div>
  <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
  </div>
</div>